import type { LineItemPropertyDisplayRow } from "@redotech/order-tracking-common/line-item-property-display";
import {
  resolveLineItemPropertyDisplayRows,
  selectDisplayableProperties,
} from "@redotech/order-tracking-common/line-item-property-display";
import type { LineItemPropertySetting } from "@redotech/order-tracking-common/tracking-page-definition";
import type { TrackingPageLineItem } from "@redotech/order-tracking-common/tracking-page-order-definition";

const PREVIEW_SAMPLE_TEXT = "Sample property";

export function getLineItemPropertyDisplayRows({
  properties,
  customFields,
  lineItemPropertySettings,
  showCustomFields,
  previewCustomFields = false,
}: {
  properties: TrackingPageLineItem["properties"];
  customFields: string[] | undefined;
  lineItemPropertySettings?: LineItemPropertySetting[];
  showCustomFields: boolean;
  previewCustomFields?: boolean;
}): LineItemPropertyDisplayRow[] {
  if (!showCustomFields) {
    return [];
  }

  if (!previewCustomFields || !customFields?.length) {
    return resolveLineItemPropertyDisplayRows({
      properties,
      customFields,
      lineItemPropertySettings,
    });
  }

  // The builder preview shows one row per configured field; fields without a
  // source value get a placeholder.
  const selectedProperties = selectDisplayableProperties(
    properties,
    customFields,
  );
  const previewProperties = customFields.map(
    (name) =>
      selectedProperties.find((candidate) => candidate.name === name) ?? {
        name,
        value: PREVIEW_SAMPLE_TEXT,
      },
  );
  return resolveLineItemPropertyDisplayRows({
    properties: previewProperties,
    customFields,
    lineItemPropertySettings,
  });
}
